<template>
    <v-layout class="header-menu header-menu__device" row>
        <v-flex xs9 class="hotel-name d-inline-flex">
            <div class="arrow-btn arrow-btn-black d-inline-flex rotate-180 mr-3" @click="$emit('back')">
                <ArrowRightIcon/>
            </div>
            <div class="title-block" v-if="roomData">
                <div>
                    <span v-if="roomData.hotel && roomData.hotel.address">{{roomData.hotel.address}}, </span>
                    <span class="common-text" v-if="roomData.name">№{{roomData.name}}</span>
                </div>
            </div>
        </v-flex>
        <v-flex class="dashboard">
            <div
                v-for="(item, index) in menu"
                :key="index"
                class="dashboard__icon"
                :class="{ 'active': item.action == activeItem }"
                @click="setItem(item)"
            >
                <v-img :src="require('@/assets/icons/' + item.icon + '.svg')" />
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import ArrowRightIcon from "@/assets/icons/ArrowRightIcon";

export default {
    name: "DeviceHeaderMenu",
    components: {ArrowRightIcon},
    props: {
        roomData: {
            type: Object,
            default: () => {},
        },
        edit: {
            type: Boolean,
            default: false,
        },
        noSettings: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menu: [
                {
                    icon: "settings_icon",
                    active: false,
                    action: "settings",
                },
                {
                    icon: "logout_icon",
                    active: false,
                    action: "logout",
                },
            ],
            activeItem: null,
        };
    },
    created() {
        if (this.noSettings) {
            this.menu.splice(0,1);
        }
        if (this.edit) {
            this.activeItem = "settings";
        }
    },
    watch: {
        activeItem(val) {
            if (val) {
                if (val == "logout") {
                    this.logOut();
                } else {
                    this.$emit("setEdit", true);
                }
            } else {
                this.$emit("setEdit", false);
            }
        },
    },
    methods: {
        logOut() {
            localStorage.removeItem("RobohotelAdminAccessToken");
            this.$router.push( '/');
            this.$router.go( 0);
        },
        setItem(item) {
            if (this.activeItem == item) {
                this.activeItem = null;
            } else {
                this.activeItem = item;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.rotate-180 {
    transform: rotate(180deg);
}
.arrow-btn svg {
    max-height: 16px;

    &:hover {
        cursor: pointer;
    }
}
</style>